<template>
  <div>
    <div
      class="ts-mt-4 ts-border-2 ts-border-dashed ts ts-py-3 ts-px-5 ts-h-24 ts-rounded-md ts-flex ts-items-center ts-space-x-1 ts-justify-center ts-overflow-y-scroll"
      :class="{ 'ts-border-blue-500': isDragOver }"
      @drop="handleOnDrop"
      @dragover.prevent="dragover"
      @dragleave.prevent="dragleave"
      @click.prevent="openFileBrowser"
    >
      <h2
        class="ts-text-gray-300 ts-font-robot ts-text-lg"
        v-if="model.files.length == 0"
      >
        <Icon type="md-folder" size="20" /> Drop file here ...
      </h2>
      <div
        v-for="(file, index) in model.files"
        :key="index"
        class="ts-w-16 ts-h-16 ts-rounded-md ts-cursor-pointer ts-border-2 ts-overflow-hidden ts-relative ts-group"
      >
        <div
          class="ts-w-full ts-h-full ts-z-20 ts-absolute group-hover:ts-block ts-hidden ts-transition-all ts-duration-300"
          style="background: #5f5f5fa6;"
        ></div>
        <div
          class="ts-w-full ts-h-full ts-z-30 ts-absolute group-hover:ts-block ts-hidden ts-transition-all ts-duration-300"
        >
          <div
            class="ts-w-full ts-h-full ts-flex ts-items-center ts-justify-center"
          >
            <button
              @click.prevent="removeFile(index)"
              class="ts-h-8 ts-w-8 ts-flex ts-items-center ts-justify-center ts-text-white ts-font-semibold ts-font-robot ts-rounded-full focus:ts-outline-none"
              style="background: rgba(182, 13, 1, 0.788)"
            >
              <Icon type="md-close" size="20" />
            </button>
          </div>
        </div>
        <div v-if="isImage(file)">
          <img
            :src="readImagePreview(file)"
            alt="Preview"
            class="ts-w-16 ts-h-16 ts-object-cover ts-object-center"
          />
        </div>
        <div
          v-else-if="isPdf(file)"
          class="ts-flex ts-items-center ts-justify-center ts-w-full ts-h-full"
        >
          <i class="fas fa-file-pdf fa-3x"></i>
        </div>
        <div
          v-else-if="isExcel(file)"
          class="ts-flex ts-items-center ts-justify-center ts-w-full ts-h-full"
        >
          <i class="fas fa-file-excel fa-3x"></i>
        </div>
        <div
          v-else
          class="ts-flex ts-items-center ts-justify-center ts-w-full ts-h-full"
        >
          <i class="fas fa-file fa-3x"></i>
        </div>
      </div>
    </div>
    <input type="file" ref="fileInput" multiple @change="handleFileSelection" />
  </div>
</template>

<script>
export default {
  props: ['value', 'validate'],
  data() {
    return {
      model: {},
      isDragOver: false
    }
  },
  created() {
    this.model = this.value
  },
  methods: {
    handleOnDrop(event) {
      event.preventDefault()
      const selectedFiles = event.dataTransfer.files
      this.processFiles(selectedFiles)
      this.isDragOver = false
    },
    dragover() {
      this.isDragOver = true
    },
    dragleave() {
      this.isDragOver = false
    },
    openFileBrowser() {
      // this.$refs.fileInput.click()
    },
    handleFileSelection(event) {
      const selectedFile = event.target.files
      this.processFiles(selectedFile)
    },
    processFiles(files) {
      for (let i = 0; i < files.length; i++) {
        const file = files[i]
        // Perform additional checks or validation if needed
        this.model.files.push(file)
      }
    },
    isImage(file) {
      return file.type.includes('image')
    },
    isPdf(file) {
      return file.type === 'application/pdf'
    },
    isExcel(file) {
      return (
        file.type ===
        'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet'
      )
    },
    readImagePreview(file) {
      return URL.createObjectURL(file)
    },
    removeFile(index) {
      this.model.files.splice(index, 1)
    }
  }
}
</script>
